function check_back_issues_collection() {
    setTimeout(function() {
        const isBackIssues = window.collectionMetadata?.is_comics_back_issues;
        if (!isBackIssues) return;

        console.log('Metadata', window.collectionMetadata);

        fix_collections_link();
        hide_collection_tags();
        hide_prices_in_collections_list();
    }, 1);
}

function schedule_back_issues_rechecks() {
    const delays = [0, 75, 250, 700, 1500];
    delays.forEach(function(delay) {
        setTimeout(function() {
            check_back_issues_collection();
        }, delay);
    });
}

function init_back_issues_collection_hooks() {
    if (window.ifBackIssuesHooksBound) return;
    window.ifBackIssuesHooksBound = true;

    // Initial load plus short retry window for late-hydrating data/DOM.
    schedule_back_issues_rechecks();

    // Back/forward cache restores often skip normal script timing.
    window.addEventListener('pageshow', function() {
        schedule_back_issues_rechecks();
    });

    // SPA-like navigation updates URL/history without full reload.
    window.addEventListener('popstate', function() {
        schedule_back_issues_rechecks();
    });
}

init_back_issues_collection_hooks();


function hide_prices_in_collections_list() {
    if (!window.collectionMetadata?.flag_hide_prices_in_collections_list) return;

    const selector = 'div.grid div.product-grid-item a.product-grid-item__price.price[data-grid-link]';

    const hidePricesInScope = function(root) {
        let matches = [];

        if (root.matches && root.matches(selector)) {
            matches.push(root);
        }

        if (root.querySelectorAll) {
            matches = matches.concat(Array.from(root.querySelectorAll(selector)));
        }

        matches.forEach(function(link) {
            link.innerHTML = '&nbsp;';
            link.style.setProperty('visibility', 'hidden', 'important');
        });
    };

    // CSS catches infinite-scroll appended cards without extra JS loops.
    if (!document.getElementById('if-hide-collection-prices-style')) {
        const style = document.createElement('style');
        style.id = 'if-hide-collection-prices-style';
        style.textContent = selector + ' { visibility: hidden !important; }';
        document.head.appendChild(style);
    }

    hidePricesInScope(document);

    if (window.ifHideCollectionPricesObserverBound) return;
    window.ifHideCollectionPricesObserverBound = true;

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node && node.nodeType === 1) {
                    hidePricesInScope(node);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}


function fix_collections_link() {
    const breadcrumbs = document.querySelector('nav.breadcrumbs');
    if (!breadcrumbs) return;

    const collectionsLink = breadcrumbs.querySelector('a.breadcrumbs__link[href="/collections"], a.breadcrumbs__link[href="/pages/back-issues"]');
    if (!collectionsLink) return;

    // Honor collection_breadcrumb_link when the collection sets one, instead
    // of always hardcoding "Publishers" / /pages/back-issues. This also runs
    // on a retry ladder (see schedule_back_issues_rechecks), so it can fire
    // after handle_collection_breadcrumb() in __if__collections.js and must
    // not clobber that fix back to "Publishers".
    const breadcrumbPage = window.collectionMetadata?.collection_breadcrumb_page;
    if (breadcrumbPage?.title && breadcrumbPage?.url) {
        collectionsLink.href = breadcrumbPage.url;
        collectionsLink.innerText = breadcrumbPage.title;
    } else {
        collectionsLink.href = '/pages/back-issues';
        collectionsLink.innerText = 'Publishers';
    }

    // Remove Home + the separator immediately after it.
    const homeLink = breadcrumbs.querySelector('a[href="/"]');
    if (homeLink) {
        const homeSep = homeLink.nextElementSibling;
        if (homeSep && homeSep.matches('span.breadcrumbs__sep')) homeSep.remove();
        homeLink.remove();
    }

    // Ensure a single "/" separator after "Publishers".
    const existingSep = collectionsLink.nextElementSibling;
    if (existingSep && existingSep.matches('span.breadcrumbs__sep')) existingSep.remove();

    const separator = document.createElement('span');
    separator.className = 'breadcrumbs__sep';
    separator.textContent = '/';
    collectionsLink.insertAdjacentElement('afterend', separator);
}


function hide_collection_tags() {
    const raw = window.collectionMetadata?.tags_to_hide;
    if (!raw) return;

    let tagsToHide = Array.isArray(raw) ? raw.slice() : [];

    if (typeof raw === 'string') {
        try {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
                tagsToHide = parsed;
            }
        } catch (err) {
            return;
        }
    }

    // Some payloads arrive as ["[\"tag-a\",\"tag-b\"]"].
    if (tagsToHide.length === 1 && typeof tagsToHide[0] === 'string') {
        const nested = tagsToHide[0].trim();
        if (nested.charAt(0) === '[') {
            try {
                const parsedNested = JSON.parse(nested);
                if (Array.isArray(parsedNested)) {
                    tagsToHide = parsedNested;
                }
            } catch (err) {
                return;
            }
        }
    }

    if (!tagsToHide.length) return;

    const normalizeTag = function(value) {
        return String(value || '')
            .trim()
            .toLowerCase()
            .replace(/['"]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    };

    tagsToHide.forEach(function(tagName) {
        const key = normalizeTag(tagName);
        if (!key) return;

        const selector = '#CollectionFilter--tags ul.collection__filter-tags li.collection__filter-tag a[data-tag="' + key + '"]';
        const matches = document.querySelectorAll(selector);

        matches.forEach(function(link) {
            const li = link.closest('li.collection__filter-tag');
            if (li) {
                li.style.setProperty('display', 'none', 'important');
            }
        });
    });
}